import { Center, Spinner } from "@reverb-ui/react";
import React from "react";
export var LoadingFullPage = function () { return (React.createElement(Center, { w: "100vw", h: "100vh" },
    React.createElement(Spinner, { thickness: "4px", speed: "0.65s", emptyColor: "gray.200", color: "blue.500", size: "xl" }))); };
